import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Anexo} from '@core/models/anexo';
import {TipoAnexo} from '@core/models/tipo-anexo';

@Injectable({
  providedIn: 'root'
})
export class DemandaAnexosService {
  private readonly uri0 = environment.api.uri;
  private readonly uri = environment.api.uri.concat('demanda-arquivo');
  private readonly http = inject(HttpClient);

  getTiposAnexos(): Observable<TipoAnexo[]> {
    return this.http.get<TipoAnexo[]>(`${this.uri0}tipos-arquivo`);
  }

  getAnexos(idDemanda: number, idTipoAnexo?: number): Observable<Anexo[]> {
    const params: Record<string, string> = {idDemanda: idDemanda.toString()};
    if (idTipoAnexo != null) params['idTipoAnexo'] = idTipoAnexo.toString();
    return this.http.get<Anexo[]>(this.uri, {params});
  }

  upload(idTipoAnexo: number, arquivo: File, idTabela?: number): Observable<Anexo> {
    const formData = new FormData();
    if (idTabela != null) formData.append('idTabela', idTabela.toString());
    formData.append('idTipoAnexo', idTipoAnexo.toString());
    formData.append('arquivo', arquivo);
    return this.http.post<Anexo>(this.uri, formData);
  }

  uploadAsync(idTipoAnexo: number, arquivo: File, idTabela?: number): Observable<Anexo> {
    const formData = new FormData();
    if (idTabela != null) formData.append('idTabela', idTabela.toString());
    formData.append('idTipoAnexo', idTipoAnexo.toString());
    formData.append('arquivo', arquivo);
    return this.http.post<Anexo>(`${this.uri}/async`, formData);
  }

  deleteTemp(nomeUnicoArquivo: string): Observable<void> {
    return this.http.delete<void>(`${this.uri}/temp`, {params: {nomeUnicoArquivo}});
  }

  delete(idArquivos: number[]): Observable<void> {
    return this.http.delete<void>(this.uri, {body: idArquivos});
  }

  download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.uri}/${id}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
